// File: src/components/Cards/FadeIn.tsx

import React, { useEffect, useState } from "react";
import "./FadeIn.css";

interface FadeInProps {
    children: React.ReactNode;
    duration?: number; // in milliseconds
}

const FadeIn: React.FC<FadeInProps> = ({ children, duration = 500 }) => {
    const [animate, setAnimate] = useState(true);

    useEffect(() => {
        const timer = setTimeout(() => setAnimate(false), duration);
        return () => clearTimeout(timer);
    }, [duration]);

    return <div className={animate ? "fade-in" : ""}>{children}</div>;
};

export default FadeIn;
